<template>
  <div class="container">
    <common-title titleName="我的订单" bcColor="#F7F8FC" />
    <div v-if="list.length >= 1" class="orderList">
      <div v-for="item in list" :key="item.borderNo" class="cardItem">
        <div class="title">
          <div class="leftIcon"></div>
          <div class="right">
            <div class="text">订单号：{{ item.borderNo }}</div>
            <div :class="[item.status === 1 ? 'pending' : 'success']">{{ statusObj[item.status] }}</div>
          </div>
        </div>
        <div class="content">
          <div class="name">{{ item.productName }}</div>
          <div class="subName">{{ item.subjectName }}</div>
          <div class="btn" @click="toOrderDetail(item.borderNo,item.bproductId)">查看详情</div>
        </div>
      </div>
    </div>
    <div v-else class="defaultEmpty">
      <img class="img" :src="url" alt="没数据">
      <div>暂无订单~</div>
    </div>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import {
  reqBilibiliOrderList,
} from '@/api/bilibiliShipments/index';

export default {
  components: {
    CommonTitle,
  },
  data() {
    return {
      url: `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/bilibiliShipments/%E6%97%A0%E5%8D%8F%E8%AE%AE%402x.png`,
      list: [],
      statusObj: { 1: '待发货', 2: '已发货' },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const { verifyCode, phone } = this.$route.query;
      const res = await reqBilibiliOrderList(verifyCode, phone);
      if (res.code === 0) {
        this.list = res.data;
      }
    },

    toOrderDetail(orderNo, bproductId) {
      const { phone } = this.$route.query;
      this.$router.push({
        path: `/bilibili-shipments/order-detail/${orderNo}`,
        query: { phone, bproductId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.container {
  height: 100%;
}
.orderList {
  background: #F7F8FC;
  padding: 100px 36px 0;

  .cardItem {
    margin-top: 22px;
    background: #FFFFFF;
    border-radius: 14px;

    .title {
      display: flex;
      align-items: center;
      padding: 29px 0;
      font-size: 25px;

      .leftIcon {
        width: 7px;
        height: 29px;
        margin-right: 22px;
        background: #FF7F41;
      }

      .right {
        display: flex;
        flex: 1;
        justify-content: space-between;
        .text {
          width: 535px;
          color: #999999;
        }

        .success {
          width: 86px;
          font-weight: 500;
          margin-right: 24px;
          color: #1DD467;
        }

        .pending {
          width: 86px;
          font-weight: 500;
          margin-right: 24px;
          color: #FF7F41;
        }
      }
    }

    .content {
      padding: 22px 0 36px 29px;
      border-top: 2px solid #F6F6F6;

      .name {
        margin-bottom: 22px;
        font-size: 29px;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
      }

      .subName {
        margin-bottom: 25px;
        font-size: 25px;
        color: #999999;
      }

      .btn {
        width: 170px;
        height: 58px;
        margin-left: 478px;
        background: #FE7F41;
        border-radius: 29px;
        text-align: center;
        color: #fff;
        font-size: 25px;
        line-height: 58px;
      }
    }
  }
}

.defaultEmpty {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  padding-top: 437px;
  background: #D8D8D8;
  font-size: 25px;
  color: #333333;

  .img {
    width: 290px;
    height: 217px;
    margin-bottom: 18px;
  }
}

</style>
